<script setup>
import UserMain from '@/components/user/UserMain.vue'
</script>

<template>
  <user-main />
</template>
